import { Routes } from '@angular/router';
import { PublicLayout } from './layout/public-layout/public-layout';
import { PrivateLayout } from './layout/private-layout/private-layout';

import { authGuard } from './core/guards/auth-guard';
import { superAdminGuard } from './core/guards/super-admin.guard';
import { adminGuard } from './core/guards/admin.guard';

import { Login } from './features/auth/pages/login/login';
import { ForgotPassword } from './features/auth/pages/forgot-password/forgot-password';
import { CompanySignup } from './features/auth/pages/company-signup/company-signup';

import { Dashboard } from './features/dashboard/pages/dashboard/dashboard';
import { Users } from './features/users/pages/users/users';
import { Companies } from './features/companies/pages/companies/companies';
import { Jobs } from './features/jobs/pages/jobs/jobs';
import { JobForm } from './features/jobs/pages/job-form/job-form';
import { JobPhotos } from './features/jobs/pages/job-photos/job-photos';
import { JobCrops } from './features/jobs/pages/job-crops/job-crops';
import { JobEnhancement } from './features/jobs/pages/job-enhancement/job-enhancement';
import { Pricing } from './features/pricing/pages/pricing/pricing';
import { SmartCull } from './features/smart-cull/pages/smart-cull/smart-cull';
import { SalesReports } from './features/sales-reports/pages/sales-reports/sales-reports';
import { AiPresets } from './features/ai-presets/pages/ai-presets/ai-presets';
import { JobErrorLogs } from './features/jobs/pages/job-error-logs/job-error-logs';
import { PresetCategories } from './features/preset-categories/pages/preset-categories/preset-categories';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth/login',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    component: PublicLayout,
    children: [
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      { path: 'login', component: Login },
      { path: 'forgot-password', component: ForgotPassword },
      { path: 'company-signup', component: CompanySignup },
    ],
  },
  {
    path: 'app',
    component: PrivateLayout,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', component: Dashboard, canActivate: [adminGuard] },
      { path: 'users', component: Users, canActivate: [adminGuard] },

      { path: 'companies', component: Companies, canActivate: [superAdminGuard] },

      { path: 'jobs', component: Jobs },
      { path: 'jobs/create', component: JobForm },
      { path: 'jobs/error-logs', component: JobErrorLogs },
      { path: 'jobs/:id', component: JobForm },
      { path: 'jobs/:id/photos', component: JobPhotos },
      { path: 'jobs/:id/crops', component: JobCrops },
      { path: 'jobs/:id/enhancement', component: JobEnhancement },

      { path: 'pricing', component: Pricing },

      { path: 'smart-cull', component: SmartCull, canActivate: [superAdminGuard] },
      { path: 'sales-reports', component: SalesReports, canActivate: [superAdminGuard] },
      { path: 'ai-presets', component: AiPresets, canActivate: [superAdminGuard] },
      { path: 'preset-categories', component: PresetCategories, canActivate: [superAdminGuard] },
    ],
  },
  {
    path: '**',
    redirectTo: 'auth/login',
  },
];